import { createSlice } from '@reduxjs/toolkit';
import { selectNone, PaymentTypeEnum, SortTypeEnum, } from '../../../consts/CommonConsts';
import { sortRecruitmentListEnum } from '../../../consts/UserConst';
const initialState = {
    ranks: [],
    payment: selectNone,
    paymentType: PaymentTypeEnum.Monthly,
    locals: [],
    industries: [],
    sort: {
        type: SortTypeEnum.Desc,
        kind: sortRecruitmentListEnum.Latest
    },
    searchedCheck: false
};
const recruitmentSearchSlice = createSlice({
    name: 'userRecruitmentSearch',
    initialState,
    reducers: {
        setSearchAction(state, action) {
            return state = action.payload;
        },
    },
});
//Actions
export const { setSearchAction, } = recruitmentSearchSlice.actions;
export default recruitmentSearchSlice;
